import React from "react";
import styles from "./ServiceBlockBerlin.module.scss";

export interface Service {
  id: string;
  title: string;
  description: string;
  list?: string[];
}

interface ServiceBlockBerlinProps {
  services: Service[];
  berlin?: boolean | false;
}

const ServiceBlockBerlin: React.FC<ServiceBlockBerlinProps> = ({
  services,
  berlin,
}) => {
  return (
    <section
      id={berlin ? styles.deAtBerlinbg : styles.deAtEubg}
      className="staticSection brxeSection"
    >
      {berlin && <div className={styles.bgDarkOverlay}></div>}
      <div className={styles.gradOverlayTop}></div>

      <div className={`topbotPads120 servSideP88 brxeContainer rowWrapStr`}>
        <div className={styles.leftBlock}>
          <h3 className={styles.blockSubtitle}>Unsere Dienstleistungen</h3>
        </div>
        <div className={styles.rightBlock}>
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`${styles.serviceItem} ${index !== 0 ? "top12" : ""}`}
            >
              <p className={styles.idBlock}>{service.id}.</p>
              <div className={styles.infoDescription}>
                <h5>{service.title}</h5>
                <p>{service.description}</p>

                {service.list?.length ? (
                  <ul>
                    {service.list.map((item, index) => (
                      <li key={index} className={styles.listItem}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                        >
                          <path
                            fill="#1F5459"
                            fillRule="evenodd"
                            d="M8 16a8 8 0 0 0 7.293-11.293l-7.96 7.96L2.666 8h2l2.667 2.667 7.235-7.235A8 8 0 1 0 8 16Z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.gradOverlayBot}></div>
    </section>
  );
};

export default ServiceBlockBerlin;
